import { IntegrationSyncType } from '@shared/enums';

export const FriendlySyncType = {
  [IntegrationSyncType.Customers]: 'Customers',
  [IntegrationSyncType.Locations]: 'Locations',
  [IntegrationSyncType.Products]: 'Products',
  [IntegrationSyncType.Salespeople]: 'Salespeople',
  [IntegrationSyncType.Transactions]: 'Transactions',
};
